import { parseHash } from './utils.js';

document.addEventListener('DOMContentLoaded', function () {
	/**
	 * Get Posts
	 */
	const get_posts = async (blockId = '', page = 1, initial = false, scroll = false, force = false) => {
		const argsData = document.querySelector(`#${blockId}`).dataset.args;
		const args = typeof argsData === 'string' ? JSON.parse(argsData) : argsData;

		if (!blockId || !args) {
			console.log('There was an issue getting the block id or args');
			return;
		}

		args.initial = initial;

		if (args.hasOwnProperty('post_loop_pagination') && args.post_loop_pagination) {
			args.paged = page != 1 ? page : 1;
		}

		let formData = {};
		document.querySelectorAll(`#${blockId} .filter-select`).forEach((select) => {
			const isDropdownList = select.classList.contains('dropdown-list');

			if (isDropdownList) {
				const selectName = select.dataset.name; // Get the value of data-name attribute
				const checkboxes = select.querySelectorAll('input[type="checkbox"]:checked:not([value="all"])'); // Exclude the checkboxes with value "all"
				if (checkboxes.length > 0) {
					const values = Array.from(checkboxes).map((checkbox) => decodeURIComponent(checkbox.value));
					formData[selectName] = values; // Use selectName instead of select.name
				}
			} else {
				const fieldName = select.name;
				const fieldValue = select.value;
				if (fieldValue && fieldValue !== 'all') {
					formData[fieldName] = decodeURIComponent(fieldValue);
				}
			}
		});

		const searchField = document.querySelector(`#${blockId} .search-input`);
		if (searchField) {
			const searchValue = searchField.value;
			if (searchValue) {
				formData[searchField.name] = searchValue;
			}
		}

		if (!Object.keys(formData).length && args.hasOwnProperty('post_loop_pagination') && !args.post_loop_pagination && !force) {
			return;
		}

		const requestData = { ...args, formData };

		// Before sending the request
		if (!initial) {
			const wpBlockPostLoop = document.querySelector(`#${blockId} .wp-block-post-loop`);
			if (wpBlockPostLoop) {
				const loader = document.createElement('div');
				loader.classList.add('loader');
				const span = document.createElement('span');
				if (args.post_loop_loader) {
					span.classList.add(args.post_loop_loader);
				}
				loader.appendChild(span);
				wpBlockPostLoop.prepend(loader);
			}
		}

		const response = await fetch(knightowl_blocks_filter_data.ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce': knightowl_blocks_filter_data.nonce,
			},
			body: JSON.stringify(requestData),
		});

		if (response.ok) {
			const result = await response.json();

			if (result.success === true) {
				const postLoopData = document.querySelector(`#${blockId} .post-loop-data`);
				if (!initial) {
					postLoopData.innerHTML = result.data;
				} else {
					postLoopData.innerHTML += result.data;
				}

				// Emit a custom event
				let event = new Event('tilesAdded');
				document.dispatchEvent(event);

				if (scroll === true && args.hasOwnProperty('post_loop_scroll_top') && args.post_loop_scroll_top === 1) {
					const postLoopData = document.querySelector(`#${blockId} .post-loop-data`);
					if (postLoopData) {
						window.scrollTo({
							top: postLoopData.offsetTop - 50,
							behavior: 'smooth'
						});
					}
				}
			} else {
				console.log('An error occurred. Please contact the site administrator.');
			}
		} else {
			console.log('REST request failed:', response.status);
		}
	}

	/**
	 * Initial call
	 */
	let clearAllClicked = false;
	const postLoopElements = document.querySelectorAll('.knightowl-blocks-post-loop');
	postLoopElements.forEach(element => {
		const blockId = element.id;

		// Initial check for hash on page load
		if (location.hash && location.hash.length) {
			hashChange();
		} else {
			get_posts(blockId, 1, true);
		}
	});

	/**
	 * Update Hash
	 */
	function hashChange() {
		postLoopElements.forEach(element => {
			const blockId = element.id;
			populateFilterFields(blockId);
		});
	}
	// Listen for hashchange event
	window.addEventListener('hashchange', hashChange);

	/**
	 * Category Filters
	 */
	let filterSelect = document.querySelectorAll('.filter-select');
	if (filterSelect.length > 0) {
		filterSelect.forEach(select => {
			select.addEventListener('change', function () {
				let block = select.closest('.knightowl-blocks-post-loop');
				if (block) {
					let blockId = block.id;
					let page;
					if (document.querySelector(`#${blockId} .pagination`)) {
						page = 1;
					}
					updateHash(blockId, page);
					if (!window.location.hash && !clearAllClicked) {
						get_posts(blockId);
					}
				}
			});
		});
	}

	/**
	 * Search
	 */
	let searchInputFields = document.querySelectorAll('.search-input');
	if (searchInputFields.length > 0) {
		searchInputFields.forEach(inputField => {
			let block = inputField.closest('.knightowl-blocks-post-loop');
			if(block) {
				let blockId = block.id;
				let searchInput = document.querySelector(`#${blockId} .search-input`);
				let filterSubmit = document.querySelector(`#${blockId} .filter-submit`);
				let filterClear = document.querySelector(`#${blockId} .filter-clear`);
				let page = null;

				if (document.querySelector('.pagination')) {
					page = 1;
				}

				searchInput.addEventListener('input', function () {
					filterClear.classList.remove('hide');
				});

				const blurHandler = function () {
					if (searchInput.value === '') {
						filterClear.classList.add('hide');
					}
					get_posts(blockId);
					updateHash(blockId, page);
					searchInput.removeEventListener('blur', blurHandler);
				};
				searchInput.addEventListener('blur', blurHandler);

				filterSubmit.addEventListener('click', function (e) {
					e.preventDefault();
					updateHash(blockId, page);
					searchInput.removeEventListener('blur', blurHandler);
				});

				filterClear.addEventListener('click', function (e) {
					e.preventDefault();
					filterClear.classList.add('hide');
					searchInput.value = '';

					// Check if any filters are set
					let filtersSet = checkFilterStatus(blockId);
					if( !filtersSet ){
						get_posts(blockId);
					}

					updateHash(blockId, page);
					searchInput.removeEventListener('blur', blurHandler);
				});
			}
		});
	}

	/**
	 * Pagination
	 */
	document.querySelector('body').addEventListener('click', function(e) {
		let targetElement = e.target;
		if(targetElement.closest('.pagination') && targetElement.matches('a')) {
			let block = targetElement.closest('.knightowl-blocks-post-loop');
			if(block) {
				let blockId = block.id;
				let page = parseInt(targetElement.getAttribute('href').replace(/\D/g, '')) || 1;
				updateHash(blockId, page);
				let filtersSet = checkFilterStatus(blockId);
				if (!/page=\d+/.test(window.location.hash) && !filtersSet) {
					get_posts(blockId, page, false, true);
				}
				e.preventDefault();
			}
		}
	});

	/**
	 * Populate filter fields based on hash values
	 */
	function populateFilterFields(blockId) {
		let hash = location.hash;
		let hashParams = parseHash(hash);

		if (hashParams) {
			// Iterate over filter-select fields and update their values based on hash params
			document.querySelectorAll(`#${blockId} .filter-select`).forEach((selectElement) => {
				let isDropdownList = selectElement.classList.contains('dropdown-list');
				let fieldName = isDropdownList ? selectElement.dataset.hash || selectElement.dataset.name : selectElement.dataset.hash || selectElement.getAttribute('name');

				if (hashParams.hasOwnProperty(fieldName)) {
					let fieldValue = hashParams[fieldName];

					if (isDropdownList) {
						// Handle input checkboxes in dropdown list
						let checkboxes = selectElement.querySelectorAll('input[type="checkbox"]');
						let fieldValues = fieldValue.split(',');
						const selectedItems = [];

						checkboxes.forEach((checkbox) => {
							let checkboxValue = checkbox.value;

							if (fieldValues.includes(checkboxValue)) {
								checkbox.checked = true;
								const labelText = checkbox.nextElementSibling.textContent;
								selectedItems.push({ value: checkbox.value, label: labelText });
							} else {
								checkbox.checked = false;
							}

							// Trigger a change event on the checkbox to update its state
							const changeEvent = new Event('change');
							checkbox.dispatchEvent(changeEvent);
						});

						const toggle = selectElement.previousElementSibling;
						const defaultText = toggle.dataset.defaultText || 'Select';

						if (selectedItems.length > 0) {
							if (selectedItems.length > 1) {
								toggle.innerHTML = '<span class="selected">' + selectedItems.length + ' Selected </span>';
							} else {
								const selectedItemsHtml = selectedItems.map(function (item) {
									return '<span class="selected-item" data-value="' + item.value + '">' + item.label + '</span>';
								}).join(', ');
								toggle.innerHTML = '<span class="selected">' + selectedItemsHtml + '</span>';
							}
						} else {
							toggle.innerHTML = '<span class="selected">' + defaultText + '</span>';
							checkboxes.forEach(function (checkbox) {
								if (checkbox.value === 'all') {
									checkbox.checked = true;
								}
							});
						}

					} else {
						// Handle select element
						selectElement.value = fieldValue;
					}
				}
			});

			// Populate search-input field if search param exists in hash
			let searchInput = document.querySelector(`#${blockId} .search-input`);
			if (hashParams.hasOwnProperty('search') && searchInput) {
				let searchValue = hashParams['search'];
				searchInput.value = searchValue;
				document.querySelector(`#${blockId} .filter-clear`).classList.remove('hide');
			}

			// Update the page value if it exists in the hash
			let page = hashParams.hasOwnProperty('page') ? parseInt(hashParams['page']) : 1;

			// Trigger the get_posts function with updated filter values
			get_posts(blockId, page, false);
			updateClearAllButton(blockId);
		}
	}

	/**
	 * Check Filter Status
	 */
	function checkFilterStatus(blockId) {
		let filterBar = document.querySelector(`#${blockId} .filter-bar`);
		let filterSelects = filterBar ? filterBar.querySelectorAll('.filter-select, .filter-select input[type="checkbox"]') : [];

		let filtersSet = Array.from(filterSelects).some((element) => {
			if (element.tagName === 'SELECT') {
				return element.value !== 'all';
			} else if (element.tagName === 'INPUT') {
				return element.checked && element.value !== 'all';
			}
			return false;
		});
		return filtersSet;
	}

	/**
	 * Clear all
	 */
	function updateClearAllButton(blockId) {
		let filterBar = document.querySelector(`#${blockId} .filter-bar`);
		let filterSelects = filterBar ? filterBar.querySelectorAll('.filter-select, .filter-select input[type="checkbox"]') : [];
		let searchInput = document.querySelector(`#${blockId} .search-input`);
		let filterClear = document.querySelector(`#${blockId} .filter-clear`);

		// Check if any filters are set
		let filtersSet = checkFilterStatus(blockId) || (searchInput && searchInput.value !== '');

		// Get the existing Clear All button if it exists
		let clearAllButton = filterBar ? filterBar.querySelector('.clear-all') : null;

		// If no filters are set and the Clear All button exists, remove it
		if (!filtersSet && clearAllButton) {
			clearAllButton.remove();
		}

		// If filters are set and the Clear All button does not exist, add it
		if (filtersSet && !clearAllButton) {
			let clearAllButtonHtml = document.createElement('a');
			clearAllButtonHtml.setAttribute('role', 'button');
			clearAllButtonHtml.setAttribute('href', '#');
			clearAllButtonHtml.classList.add('clear-all');
			clearAllButtonHtml.setAttribute('aria-label', knightowl_translations.clear_all_filters);
			clearAllButtonHtml.textContent = knightowl_translations.clear_all;
			filterBar.append(clearAllButtonHtml);

			// Add the event handler to the new Clear All button
			clearAllButtonHtml.addEventListener('click', function (e) {
				e.preventDefault();
				clearAllClicked = true;

				// Clear the filter-select fields
				filterSelects.forEach((element) => {
					if (element.tagName === 'SELECT') {
						element.value = 'all';
					} else if (element.tagName === 'INPUT' && element.value !== 'all') {
						element.checked = false;
					}
				});

				// Clear the search input
				if( filterClear ){
					filterClear.classList.add('hide');
				}
				if (searchInput) {
					searchInput.value = '';
				}

				// Trigger the filter change event
				filterSelects.forEach((element) => {
					if (element.tagName === 'SELECT' || (element.tagName === 'INPUT' && element.value !== 'all')) {
						element.dispatchEvent(new Event('change'));
					}
				});

				// Remove the Clear All button
				this.remove();
				let filtersSet = checkFilterStatus(blockId);
				if ( !filtersSet ) {
					get_posts(blockId, 1, false, false, true);
					history.replaceState('', document.title, window.location.pathname + window.location.search);
				}
				clearAllClicked = false;
			});
		}
	}

	/**
	 * Hide Featured if Filtering or Searching
	 */
	function hideFeaturedIfFiltered(blockId, hash) {
		const featuredElement = document.querySelector(`#${blockId} .wp-block-post-loop-featured`);
		if (featuredElement && featuredElement.classList.contains('hide-filtered')) {
			if (hash === '') {
				featuredElement.style.display = 'block';
			} else {
				featuredElement.style.display = 'none';
			}
		}
	}

	/**
	 * Update the hash with the current filter and search values
	 */
	function updateHash(blockId, page) {
		let hashParams = {};

		// Get the filter values
		Array.from(document.querySelectorAll(`#${blockId} .filter-select`)).forEach(select => {
			const isDropdownList = select.classList.contains('dropdown-list');

			if (isDropdownList) {
				const selectName = select.dataset.hash || select.dataset.name; // Get the value of data-name attribute
				const checkboxes = select.querySelectorAll('input[type="checkbox"]:checked:not([value="all"])'); // Exclude the checkboxes with value "all"
				if (checkboxes.length > 0) {
					const values = Array.from(checkboxes).map((checkbox) => checkbox.value);

					hashParams[selectName] = values;
				}
			} else {
				const fieldName = select.dataset.hash || select.name;
				const fieldValue = select.value;

				if (fieldValue && fieldValue !== 'all') {
					hashParams[fieldName] = fieldValue;
				}
			}
		});

		// Get the search value
		let searchInput = document.querySelector(`#${blockId} .search-input`);
		let searchValue = searchInput ? searchInput.value : '';

		// Check if search value exists
		if (searchValue) {
			hashParams['search'] = searchValue;
		}

		// Check if pagination exists
		if (page && page !== 1) {
			hashParams['page'] = page;
		}

		// Update the hash
		let hash = '';
		for (let key in hashParams) {
			if (hashParams.hasOwnProperty(key)) {
				if (hash !== '') {
					hash += '&';
				}
				hash += key + '=' + encodeURIComponent(hashParams[key]);
			}
		}

		// Remove the hash symbol if there are no hash parameters
		if (hash === '') {
			history.replaceState('', document.title, window.location.pathname + window.location.search);
		} else {
			location.hash = hash;
		}

		updateClearAllButton(blockId);
		hideFeaturedIfFiltered(blockId, hash);
	}
});
